import { render, staticRenderFns } from "./ActivePostDocs.vue?vue&type=template&id=4ebf192c&scoped=true&"
import script from "./ActivePostDocs.vue?vue&type=script&lang=js&"
export * from "./ActivePostDocs.vue?vue&type=script&lang=js&"
import style0 from "./ActivePostDocs.vue?vue&type=style&index=0&id=4ebf192c&prod&lang=css&"
import style1 from "./ActivePostDocs.vue?vue&type=style&index=1&id=4ebf192c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf192c",
  null
  
)

export default component.exports